/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocationCategory } from './AssetAllocationCategory';
import {
    AssetAllocationCategoryFromJSON,
    AssetAllocationCategoryFromJSONTyped,
    AssetAllocationCategoryToJSON,
} from './AssetAllocationCategory';

/**
 * 
 * @export
 * @interface AccountAssetAllocation
 */
export interface AccountAssetAllocation {
    /**
     * 
     * @type {AssetAllocationCategory}
     * @memberof AccountAssetAllocation
     */
    category: AssetAllocationCategory;
    /**
     * 
     * @type {number}
     * @memberof AccountAssetAllocation
     */
    exposure?: number;
}



/**
 * Check if a given object implements the AccountAssetAllocation interface.
 */
export function instanceOfAccountAssetAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;

    return isInstance;
}

export function AccountAssetAllocationFromJSON(json: any): AccountAssetAllocation {
    return AccountAssetAllocationFromJSONTyped(json, false);
}

export function AccountAssetAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountAssetAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': AssetAllocationCategoryFromJSON(json['category']),
        'exposure': !exists(json, 'exposure') ? undefined : json['exposure'],
    };
}

export function AccountAssetAllocationToJSON(value?: AccountAssetAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': AssetAllocationCategoryToJSON(value.category),
        'exposure': value.exposure,
    };
}

